import { render, staticRenderFns } from "./order_add.vue?vue&type=template&id=08dd1100&scoped=true&"
import script from "./order_add.vue?vue&type=script&lang=js&"
export * from "./order_add.vue?vue&type=script&lang=js&"
import style0 from "./order_add.vue?vue&type=style&index=0&id=08dd1100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd1100",
  null
  
)

export default component.exports